/**
 * De wekkerreden in gewone woorden (sessie 48). De zaak toonde de
 * technische sleutel ("wacht_op_klant"); dezelfde woorden als de kaart
 * en de tijdlijn (``werkplek_wekkers.REDEN_LABEL``).
 */
export const WEKKER_REDEN: Record<string, string> = {
  onderweg: "zending onderweg",
  wacht_op_klant: "wacht op klant",
  case: "case bij de vervoerder",
  handmatig: "zelf gezet",
  klacht: "belofte bij een klacht",
};

export function wekkerReden(reden: string): string {
  return WEKKER_REDEN[reden] ?? reden.replace(/_/g, " ");
}
